
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kindergarten",
      function () {
        return require("private-next-pages/kindergarten.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kindergarten"])
      });
    }
  